import Persona from '@/@types/Persona';
import ISkillSet from '@/@types/ISkillSet';

export const skills: ISkillSet[] = [
  {
    title: 'Backend',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'Elastic Search',
      'Firebase',
      'GraghQL',
      'Information Architecture',
      'MongoDB',
      'MySQL',
      'PostgreSQL',
      'Redis',
      'Prisma',
      'REST',
    ].sort(),
  },
  {
    title: 'CSS',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'CSS2/3',
      'Less',
      'Print',
      'Responsive',
      'Sass',
      'Screen',
      'Stylus',
    ].sort(),
  },
  {
    title: 'Design',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'Animation',
      'Direction & Execution',
      'Invision',
      'Motion Graphics',
      'Pipeline Creation',
      'Photography',
      'Photoshop/Illustrator',
      'Sketch',
      'UX/UI',
    ].sort(),
  },
  {
    title: 'Languages',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      '.Net',
      'ActionScript',
      'Bash',
      'CSS/HTML/JSON/XML/YML',
      'JavaScript',
      'PHP',
      'Python',
      'Ruby',
      'Unity',
    ].sort(),
  },
  {
    title: 'JavaScript',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'Angular',
      'Cordova/PhoneGap',
      'Ember/Knockout',
      'ES5/ES6',
      'GSAP',
      'Node/Express',
      'Phaser',
      'Pug/Jade',
      'React',
      'SocketIO',
      'TypeScript',
      'Vue/Nuxt',
    ].sort(),
  },
  {
    title: 'Dev Ops',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'Ansible',
      'AWS',
      'Digital Ocean',
      'Docker',
      'Google Cloud Platform',
      'Heroku',
      'IBM Cloud',
      'Kubernetes',
      'KPI/Cadence',
      'Vagrant',
    ].sort(),
  },
  {
    title: 'Project Management',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'Asana', 'Trello',
      'Monday.com',
      'Jira',
      'Confluence',
      'Pivotal Tracker',
      'KanBan',
      'Scrum/Standups',
    ].sort(),
  },
  {
    title: 'Miscellaneous',
    personas: [
      Persona.Developer,
      Persona.Founder,
      Persona.Maker,
    ],
    items: [
      'TechStars: Boulder 2018 Alumni',
      'BEM Architecture',
      'Curiosity vs Rigidity vs Scalability',
      'Game Mechanics',
      'Legos... Seriously',
      'HIPAA Compliance',
      'Mentoring/Coaching',
      'MVC, Object Oriented',
      'Startup Culture & Process',
    ].sort(),
  },
];

export default skills;
